<template>
<div class="chapter">
<div class="inner_page">
<div class="image-wrap">
<div class="image">
<img alt="image" class="calibre1" src="images/frontline-logo-small.jpg"/>
</div>
</div>
<p class="paracenter1">This edition of <em class="calibre10">On the Road with Wellington</em><br class="calibre9"/>First published 1999 by<br class="calibre9"/>Greenhill Books<br/>published in this format in 2015 by<br/>Frontline Books<br/>an imprint of<br/>Pen &amp; Sword Books Ltd<br/>47 Church Street, Barnsley, S70 2AS<br/><a href="http://www.frontline-books.com" target="_blank">www.frontline-books.com</a></p>
<p class="paracenter1">Translation © University of Edinburgh, 1924<br class="calibre9"/>Introduction © Bernard Cornwell, 1999</p>
<p class="paracenter1">All rights reserved. No part of this publication may be reproduced, stored in<br class="calibre9"/>a retrieval system or transmitted in any form or by any means, electronic,<br class="calibre9"/>mechanical or otherwise without the written permission of the Publisher.</p>
<p class="paracenter1"><em class="calibre10">British Library Cataloguing in Publication Data</em><br class="calibre9"/>Schaumann, A. L. F.<br class="calibre9"/>On the road with Wellington: the diary of a war commissary. -<br class="calibre9"/>(Napoleonic Library; 34)<br class="calibre9"/>1. Peninsular War, 1807–1814 - Personal narratives, German<br class="calibre9"/>I. Title<br class="calibre9"/>940.2’7</p>
<p class="paracenter1">ISBN 1-85367-353-6</p>
<p class="paracenter1"><em class="calibre10">Library of Congress Cataloging-in-Publication Data</em><br class="calibre9"/>Schaumann, August Ludolf Friedrich, 1778–1840.<br class="calibre9"/>On the road with Wellington: the diary of a war commissary/by<br class="calibre9"/>A. L. F. Schaumann; introduction by Bernard Cornwell. p.      cm.<br class="calibre9"/>ISBN 1-85367-353-6<br class="calibre9"/>1. Schaumann, August Ludolf Friedrich, 1778-1840—Diaries.<br class="calibre9"/>2. Peninsular War, 1807-1814—Personal narratives, German. 3. Great<br class="calibre9"/>Britain, Army. King’s German Legion—Diaries. I. Title.</p>
<table class="paracenter2" width="80%">
<colgroup><col class="calibre11"/>
<col class="calibre11"/>
</colgroup><tbody class="calibre12">
<tr class="calibre13">
<td class="calibre14">DC232.S43 1999</td>
<td class="calibre14">
</td></tr>
<tr class="calibre13">
<td class="calibre14">940. 2’7—dc21</td>
<td class="calibre15">98-49193</td>
</tr>
<tr class="calibre13">
<td class="calibre14">
</td><td class="calibre15">CIP</td>
</tr>
</tbody>
</table>
<p class="paracenter1">Publishing History<br class="calibre9"/><em class="calibre10">On the Road with Wellington: The Diary of a War Commissary in the<br class="calibre9"/>Peninsular Campaigns</em> was translated and edited from the German by<br class="calibre9"/>Anthony M. Ludovici and first published in 1924 (William Heinemann Ltd.,<br class="calibre9"/>London). The text is now reproduced complete and unabridged, with the<br class="calibre9"/>addition of a new Introduction by Bernard Cornwell. The original watercolours<br class="calibre9"/>have been omitted for reasons of reproduction quality.</p>
<p class="paracenter1">Printed and bound in Great Britain by<br class="calibre9"/>Creative Print and Design (Wales), Ebbw Vale.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0003.vue?02555862